//GLIDE
import Glide from '@glidejs/glide';
import {
	siblings
} from '@glidejs/glide/src/utils/dom';
//GSAP
import gsap from "gsap";

const caption = '.animate .carousel-caption';
let foreground = '.animate .foreground';
let background = '.animate .background';

//Create the Component
const AnimateClass = function (Glide, Components, Events) {
	var Component = {
		changeActiveSlide() {
			let slide = Components.Html.slides[Glide.index];
			slide.classList.add('animate');

			siblings(slide).forEach((sibling) => {
				sibling.classList.remove('animate');
			});
		},
	};

	Events.on('move.after', () => {
		Component.changeActiveSlide();
		scAnimations(caption, foreground);
	});

	return Component;
};


//Fire the Slider
let showcaseCarousel = new Glide('#fp-showcase-carousel', {
	type: 'carousel',
	autoplay: 7000,
});

var ww = $(window).width();
if (ww > 960) {
	showcaseCarousel.mount({
		'AnimateClass': AnimateClass,
	});
} else {
	showcaseCarousel.mount();
}

//Define the ANIMATION
function scAnimations(caption, foreground) {
	if (caption.length) {
		gsap.fromTo(caption, {
			x: -1000
		}, {
			duration: .75,
			delay: 1,
			x: 0,
			ease: 'elastic.out(.6, 0.4)'
		});
	}

	if (foreground.length) {
		gsap.fromTo(foreground, {
			y: -1000
		}, {
			duration: 1.1,
			y: 0,
			ease: 'bounce'
		});
	}
}